export default "__VITE_ASSET__D6jw4zAQ__"